import { render, staticRenderFns } from "./forgotPasswordScreen.vue?vue&type=template&id=46cf0546&"
import script from "./forgotPasswordScreen.vue?vue&type=script&lang=js&"
export * from "./forgotPasswordScreen.vue?vue&type=script&lang=js&"
import style0 from "./forgotPasswordScreen.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports